/**
 * Created by rhinov15 on 04/01/2016.
 */
/**
 * Graphical node for representing junction point when selected or hovered
 *
 */
import { Events, eventsManager } from "@rhinov/savane-js";
import { PlanManager } from "../../../../cocosPlan";

declare var cc: any;


export class AngleNode extends cc.Sprite {
    constructor(zoom: number) {
        // Call parent class constructor for init
        super();
        // Load sprite texture
        this.initWithSpriteFrameName('plan/conerAngle.png');

        // We will draw 3 things, 2 lines and a point, create and add them to the renderer
        this.line1 = new cc.DrawNode();
        this.line2 = new cc.DrawNode();
        this.point = new cc.DrawNode();
        this.addChild(this.line1, -1);
        this.addChild(this.line2, -1);
        this.addChild(this.point, -0.5);

        // We will also display the angle value, font size 13 pts, create it and add them to the renderer
        this.angleLabel = new cc.LabelTTF('', 'Roboto-Light', 13, new cc.size(0, 18), cc.TEXT_ALIGNMENT_CENTER, cc.TEXT_ALIGNMENT_CENTER);
        this.angleLabel.setColor(new cc.color(0, 0, 0));
        this.addChild(this.angleLabel, 10);

        // We will also display the angle value, font size 13 pts, create it and add them to the renderer
        this.angleLabel2 = new cc.LabelTTF('', 'Roboto-Light', 13, new cc.size(0, 18), cc.TEXT_ALIGNMENT_CENTER, cc.TEXT_ALIGNMENT_CENTER);
        this.angleLabel2.setColor(new cc.color(0, 0, 0));
        this.addChild(this.angleLabel2, 10);

        // Scale the point accoding to the zoom level
        this.point.setScale(Math.sqrt(zoom) / 1.3);

        // Set the position of everything
        var size = this.getContentSize().width / 2;
        this.line1.setPosition(new cc.p(size, size));
        this.line2.setPosition(new cc.p(size, size));
        this.point.setPosition(new cc.p(size, size));

        // Colors to display elements
        var yellow = new cc.color('#F5D231');
        var grey = new cc.color('#555b62');

        var borderThickness = 1;
        if (borderThickness * PlanManager.getInstance().getZoomScale() < 1 || borderThickness * PlanManager.getInstance().getZoomScale() > 1) {
            borderThickness /= PlanManager.getInstance().getZoomScale();
        }

        var hooverVertex1 = [new cc.p(0, -3), new cc.p(0, 3), new cc.p(size, 3), new cc.p(size, -3)];
        var hooverVertex2 = [new cc.p(0, -3), new cc.p(0, 3), new cc.p(size, 3), new cc.p(size, -3)];
        this.line1.drawPoly(hooverVertex1, grey, borderThickness, grey);
        this.line2.drawPoly(hooverVertex2, grey, borderThickness, grey);

        hooverVertex1 = [new cc.p(0, -2), new cc.p(0, 2), new cc.p(size, 2), new cc.p(size, -2)];
        hooverVertex2 = [new cc.p(0, -2), new cc.p(0, 2), new cc.p(size, 2), new cc.p(size, -2)];
        this.line1.drawPoly(hooverVertex1, yellow, borderThickness, yellow);
        this.line2.drawPoly(hooverVertex2, yellow, borderThickness, yellow);

        this.point.drawDot(new cc.p(0, 0), 13, grey);
        this.point.drawDot(new cc.p(0, 0), 10, yellow);
    }

     /**
     * Remove listener added for zoomUpdate
     */
    removeListener () {
        eventsManager.instance.removeListener(this.zoomListener);
    }

    /**
     * Update the drawing for this node, prepare for a new frame
     */
    updateDrawing (angle1: number, angle2: number) {
        // Update lines for the angle
        this.line1.setRotation(angle1 * 360.0 / (Math.PI * 2.0));
        this.line2.setRotation(angle2 * 360.0 / (Math.PI * 2.0));

        // Compute angle value to display
        var angle = Math.round((angle1 - angle2) * 360.0 / (Math.PI * 2.0));
        // Compute new position for the angle label
        var anglePos = (angle1 + angle2) / 2;
        var position = new cc.p(this.getContentSize().width / 2, this.getContentSize().width / 2);

        // Cap the angle between 0 and 360° (0 and 2PI)
        if (angle < 0) {
            angle = -angle;
        }
        if (angle > 180) {
            angle = 360 - angle;
            anglePos = Math.PI + anglePos;
        }

        position.x += Math.cos(Math.PI - anglePos) * 40;
        position.y += Math.sin(Math.PI - anglePos) * 40;
        // Set the new position for the angle label
        this.angleLabel.setPosition(position);
        // And set its content
        this.angleLabel.setString(360 - angle + '°');

        position = new cc.p(this.getContentSize().width / 2, this.getContentSize().width / 2);

        position.x += Math.cos(2 * Math.PI - anglePos) * 40;
        position.y += Math.sin(2 * Math.PI - anglePos) * 40;
        // Set the new position for the angle label
        this.angleLabel2.setPosition(position);
        // And set its content
        this.angleLabel2.setString(angle + '°');
    }

    // Called when an object is created
    onEnter () {
        // Call parent class
        super.onEnter();
        //Attach listener for zoom update to avoid scaling with parent
        this.zoomListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, (_event: any) => {
            // Get the zoom value
            var zoom = _event.getUserData();
            // We don't want to display something too small, cap the zoom
            zoom = zoom < 0.5 ? 0.5 : zoom;
            // Then scale the node
            this.setScale(1.3 / Math.sqrt(zoom));
            this.point.setScale(Math.sqrt(zoom) / 1.3);
        });
    }

    // Called when the object is destroyed
    onExit () {
        // Call parent class
        super.onExit();
        // Remove the attached listeners
        this.removeListeners();
    }

    // Remove the listeners attached to the object
    removeListeners () {
        eventsManager.instance.removeListener(this.zoomListener);
    }
}